import _ from "lodash";

export function getArrayDifferences(arr1, arr2) {
  const length = Math.max(arr1.length, arr2.length);
  const diffs = {};

  for (let i = 0; i < length; i++) {
    const val1 = arr1[i];
    const val2 = arr2[i];

    if (_.isPlainObject(val1) && _.isPlainObject(val2)) {
      const nested = getChangedFields(val1, val2);
      if (!_.isEmpty(nested)) {
        diffs[i] = nested;
      }
    } else if (!_.isEqual(val1, val2)) {
      diffs[i] = { from: val2, to: val1 };
    }
  }

  return diffs;
}

export function getChangedFields(obj1 = {}, obj2 = {}) {
  const changes = {};
  const allKeys = _.union(_.keys(obj1), _.keys(obj2));

  allKeys.forEach((key) => {
    const val1 = obj1[key];
    const val2 = obj2[key];

    if (_.isArray(val1) && _.isArray(val2)) {
      const arrayDiffs = getArrayDifferences(val1, val2);
      if (!_.isEmpty(arrayDiffs)) {
        changes[key] = arrayDiffs;
      }
    } else if (_.isPlainObject(val1) && _.isPlainObject(val2)) {
      const nestedChanges = getChangedFields(val1, val2);
      if (!_.isEmpty(nestedChanges)) {
        changes[key] = nestedChanges;
      }
    } else if (!_.isEqual(val1, val2)) {
      changes[key] = { from: val2, to: val1 };
    }
  });

  return changes;
}

export function hasChanged(obj1, obj2) {
  const changes = getChangedFields(obj1, obj2);
  return !_.isEmpty(changes);
}

export function hasChangedFast(obj1 = {}, obj2 = {}) {
  if (_.isEqual(obj1, obj2)) return false;
  return true;
}

export function getChangesWithFlag(obj1, obj2) {
  const changes = getChangedFields(obj1, obj2);
  return {
    changed: !_.isEmpty(changes),
    changes,
  };
}
